import { useState } from "react";
import "./App.css";
import Footer from "./Footer";
import { eventIdToDisplayName, eventIdToTotalPeople } from "./constants";
import { db } from "./firebase.js";

function App() {
  const [enteredTime, setEnteredTime] = useState("");
  const [eventId, setEventId] = useState("333");
  const [closestCompetitor, setClosestCompetitor] = useState(null);

  const calculatePercentile = (rank, totalPeople) => {
    let percentile = (rank / totalPeople) * 100;
    // For small numbers, use higher precision
    if (percentile < 1) {
      return percentile.toFixed(3);
    }
    return percentile.toFixed(2);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setClosestCompetitor(null);
    const numEnteredTime = Number(enteredTime);
    if (
      numEnteredTime === 0 ||
      isNaN(numEnteredTime) ||
      numEnteredTime > Math.pow(10, 5)
    ) {
      // Don't do anything
      return;
    }
    db.collection("averageTimes")
      .where("eventId", "==", eventId)
      .where("time", ">=", numEnteredTime)
      .limit(1)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          // TODO: deal with last place
        } else {
          const doc = querySnapshot.docs[0];
          setClosestCompetitor(doc.data());
        }
      });
  };

  return (
    <>
      <div className="container">
        <h1>How fast am I?</h1>
        <p>
          Enter your average time below and this tool will tell you where that
          time would rank you amongst WCA competitors!
        </p>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="event">Select event : </label>
            <select
              id="event"
              value={eventId}
              onChange={(e) => {
                setEventId(e.target.value);
                // Reset results on event change
                setClosestCompetitor(null);
              }}
            >
              {Object.keys(eventIdToDisplayName).map((eventId, i) => (
                <option key={i} value={eventId}>
                  {eventIdToDisplayName[eventId]}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            <label htmlFor="time">Enter Average Time (in seconds) : </label>
            <input
              id="time"
              type="number"
              step="any"
              value={enteredTime}
              onChange={(e) => setEnteredTime(e.target.value)}
            />
          </div>

          <input className="button" type="submit" value="Submit" />
        </form>
        {closestCompetitor ? (
          <div className="result">
            <p>
              You would be ranked #
              {closestCompetitor.worldRank.toLocaleString()} in the world out of{" "}
              {eventIdToTotalPeople[eventId].toLocaleString()} total
              competitors. This puts you in the top{" "}
              {calculatePercentile(
                closestCompetitor.worldRank,
                eventIdToTotalPeople[eventId]
              )}{" "}
              %.
            </p>
            <p>
              The person with the closest time to you is{" "}
              <a
                href={`https://www.worldcubeassociation.org/persons/${closestCompetitor.personID}`}
              >
                {" "}
                {closestCompetitor.personName}{" "}
              </a>
              with an average time of {closestCompetitor.time} seconds.
            </p>
          </div>
        ) : null}
      </div>
      <Footer />
    </>
  );
}

export default App;
